import { PlacesContainer } from './views/places/PlacesContainer'
export default PlacesContainer
